import { mdiPublish, mdiPublishOff } from "@mdi/js";
import _DatabaseModel from "./_DatabaseModel";

class Article extends _DatabaseModel {
  static model = "article";
  static editDialogComponent = "article-edit-dialog";
  static createNewObject = { object: {}, params: {} };

  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];

  static show = {
    buttons: ["edit"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: ["name", "service_id", "type", "status"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static cardFields(object) {
    return {
      title: object.name,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static article_types = ["faq", "how_to", "troubleshooting"];

  static article_statuses = ["draft", "published", "archived"];

  static submenuActions = [
    {
      action: "publishArticle",
      icon: mdiPublish,
      titleKey: "article.label.publish_article",
      display: (object) => !object.published_at && object.permissions?.publish,
    },
    {
      action: "withdrawArticle",
      icon: mdiPublishOff,
      titleKey: "article.label.withdraw_article",
      display: (object) => object.published_at && object.permissions?.withdraw,
    },
    this.commonActions.openActivities,
    this.commonActions.archive,
  ];

  static archivedActions = [
    this.commonActions.restore,
    this.commonActions.delete,
  ];
}

export default Article;
